import { createLogger } from '@packages/logger';
/**
 * Shared logger for the i18n module. The namespace matches the Sentry `module` tag, so
 * log lines and Sentry events correlate. Import this in non-React code (sagas, apollo links,
 * utils); React components/hooks should prefer `useLogger()` from `@packages/logger/react`.
 */
export const log = createLogger('i18n');
